/**
 * Connection Status Indicator
 */

import { useMScaleStore } from '../../store'

export function ConnectionStatus() {
  const isConnected = useMScaleStore((state) => state.isConnected)
  const deviceName = useMScaleStore((state) => state.deviceName)
  const firmwareVersion = useMScaleStore((state) => state.firmwareVersion)
  const connectionError = useMScaleStore((state) => state.connectionError)

  if (connectionError) {
    return (
      <div className="flex items-center gap-2 text-red-600 dark:text-red-400">
        <div className="w-3 h-3 rounded-full bg-red-600 dark:bg-red-400" />
        <div className="text-sm">
          <div className="font-medium">Error</div>
          <div className="text-xs opacity-75">{connectionError}</div>
        </div>
      </div>
    )
  }

  if (isConnected) {
    return (
      <div className="flex items-center gap-1.5 text-green-600 dark:text-green-400">
        <div className="w-2 h-2 rounded-full bg-green-600 dark:bg-green-400 animate-pulse flex-shrink-0" />
        <div className="text-xs leading-tight">
          <div className="font-medium truncate max-w-[120px] sm:max-w-none">
            {deviceName}
          </div>
          {firmwareVersion && (
            <div className="opacity-75">v{firmwareVersion}</div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2 text-gray-400 dark:text-industrial-text-dim">
      <div className="w-3 h-3 rounded-full bg-gray-400 dark:bg-industrial-text-dim" />
      <span className="text-sm font-medium">Disconnected</span>
    </div>
  )
}
